import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [{
            path: '/',
            redirect: '/login'
        },

        {
            path: '/',
            component: () =>
                import ( /* webpackChunkName: "home" */ '@/pages/Home.vue'),
            meta: {

                title: '自述文件'
            },

            children: [{
                    //首页
                    path: 'Dashboard',
                    component: () =>
                        import ('@/pages/Dashboard.vue'),
                    meta: {
                        // 添加该字段，表示进入这个路由是需要登录的
                        requireAuth: true
                    }
                },
                {

                    //bug管理
                    path: 'bugManagement',
                    component: () =>
                        import ('../components/bugManagement/bugManagement.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {
                    // 分润列表
                    path: 'percentage',
                    component: () =>
                        import ('../components/percentage/percentage.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {
                    //帮助中心
                    path: 'helpcenter',
                    component: () =>
                        import ('../components/helpCenter/HelpCenter.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {
                    //轮播活动
                    path: 'activeCircleList',
                    component: () =>
                        import ('../components/active/activeLists.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {
                    path: '/serviceFee',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/serviceFee/serviceFeeLists.vue'),
                    meta: {
                        title: '城市服务费管理'
                    }
                },
                {
                    //服务费管理导出
                    path: 'serviceFeeExcel',
                    component: () =>
                        import ('../components/serviceFee/serviceFeeExcel.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    path: '/business',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/business/businessList.vue'),
                    meta: {
                        title: '商家合作'
                    }
                },
                // {
                //     path: '/alipayCoupon',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/alipayCoupon/alipayCouponList.vue'),
                //     meta: {
                //         title: '优惠券管理'
                //     }
                // },
                // {
                //     path: '/aliDevlivery',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/aliDevlivery/aliDevliveryList.vue'),
                //     meta: {
                //         title: '支付宝推广计划管理'
                //     }
                // },
                // {
                //     path: '/alipayCouponCode',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/alipayCoupon/alipayCouponCode/alipayCouponCodeList.vue'),
                //     meta: {
                //         title: '优惠券码管理'
                //     }
                // },
                {
                    path: '/businessWalletCash',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/business/businessCashLists/businessWalletCash.vue'),
                    meta: {
                        title: '商家提现'
                    }
                },
                {
                    path: '/inviteCode',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/inviteCode/inviteCodeLists.vue'),
                    meta: {
                        title: '司机邀请拉新'
                    }
                },
                // {
                //     path: '/Card',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/card/cardLists.vue'),
                //     meta: {
                //         title: '畅行卡'
                //     }
                // },
                // {
                //     path: '/purchaseHistory',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/purchaseHistory/purchaseHistoryLists.vue'),
                //     meta: {
                //         title: '购买记录'
                //     }
                // },
                // {
                //     path: '/usagRecord',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/usagRecord/usagRecordLists.vue'),
                //     meta: {
                //         title: '使用记录'
                //     }
                // },
                // {
                //     //保险审核
                //     path: 'inserance',
                //     component: () =>
                //         import ('../components/driver/inserance/inserance.vue'),
                //     meta: {

                //         requireAuth: true
                //     }
                // },
                {
                    // 超级管理员
                    path: 'administrator',
                    component: () =>
                        import ('../components/administrator/AdminIstrator.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 超管角色
                    path: 'administratorRole',
                    component: () =>
                        import ('../components/administratorRole/administratorRole.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 项目跟踪
                    path: 'projectFollow',
                    component: () =>
                        import ('../components/projectFollow/ProjectFollow.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 城市管理
                    path: 'city',
                    component: () =>
                        import ('../components/city/city.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /** 系统管理 */
                    //    app更新管理
                    path: 'appToUpdate',
                    component: () =>
                        import ('../components/appToUpdate/appToUpdate.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //bug管理
                    path: 'bugManagement',
                    component: () =>
                        import ('../components/bugManagement/bugManagement.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /**市场管理**/
                    //公司管理
                    path: 'company',
                    component: () =>
                        import ('../components/company/company.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /**日志管理 */
                    //   超管员日志
                    path: 'superAdminLog',
                    component: () =>
                        import ('../components/logList/superAdminLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //推送日志
                    path: 'pushLog',
                    component: () =>
                        import ('../components/logList/pushLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //用户日志
                    path: 'userLog',
                    component: () =>
                        import ('../components/logList/userLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //短信日志
                    path: 'messageLog',
                    component: () =>
                        import ('../components/logList/messageLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //验证码日志
                    path: 'codeLog',
                    component: () =>
                        import ('../components/logList/codeLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {

                    //订单管理
                    path: 'substituteDrivingOrder',
                    component: () =>
                        import ('../components/substituteDrivingOrder/substituteDrivingOrder.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /* 订单中心 */
                    //  历史订单
                    path: 'orderHistory',
                    component: () =>
                        import ('../components/substituteDrivingOrder/orderHistory.vue'),
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    //订单导出
                    path: 'orderExport',
                    component: () =>
                        import ('../components/substituteDrivingOrder/orderExport.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /* 乘客管理 */
                    //乘客信息
                    path: 'user',
                    component: () =>
                        import ('../components/user/user.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客账单
                    path: 'userBill',
                    component: () =>
                        import ('../components/user/userBill.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客绑卡
                    path: 'userBankCard',
                    component: () =>
                        import ('../components/user/userBankCard/userBankCard.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //用户订单需求
                    path: 'demandLists',
                    component: () =>
                        import ('../components/demandLists/demandLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客信息导出
                    path: 'userExport',
                    component: () =>
                        import ('../components/user/userExport.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {

                //     //乘客在线支付
                //     path: 'consumerRecharge',
                //     component: () =>
                //         import ('../components/user/consumerRecharge.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {

                    //优惠券列表
                    path: 'couponLists',
                    component: () =>
                        import ('../components/coupon/couponLists/couponLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //优惠券类型
                    path: 'couponType',
                    component: () =>
                        import ('../components/coupon/couponType/couponClassLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //优惠券日志
                    path: 'couponRecordLists',
                    component: () =>
                        import ('../components/coupon/couponRecordLists/couponRecordLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //订单模式
                    path: 'orderModel',
                    component: () =>
                        import ('../components/orderModel/orderModel.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //公告
                    path: 'article',
                    component: () =>
                        import ('../components/article/article.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {

                    //更新缓存
                    path: 'synchronization',
                    component: () =>
                        import ('../components/upTableSubmit/synchronization.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //异业联盟
                    path: 'ipcShopping',
                    component: () =>
                        import ('../components/ipcShopping/ipcShopping.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {

                //     //签约优惠
                //     path: 'signingPreferential',
                //     component: () =>
                //         import ('../components/driver/signingPreferential/signingPreferential.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {

                    //司机段位
                    path: 'driverDan',
                    component: () =>
                        import ('../components/driver/driverDan/driverDan.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //招募司机
                    path: '/driverRecruit',
                    component: () =>
                        import ('../components/driver/driverRecruit/driverRecruit.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //上传文件加分
                    path: '/batch',
                    component: () =>
                        import ('../components/driver/batch/batch.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机提现
                    path: '/driverWalletCash',
                    component: () =>
                        import ('../components/driver/driverWalletCash/driverWalletCash.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /* 司机 */
                    //司机信息
                    path: 'driver',
                    component: () =>
                        import ('../components/driver/driver.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {

                    //签约审核
                    path: 'determine',
                    component: () =>
                        import ('../components/determine/determine.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {

                //     //绑卡信息
                //     path: 'driverBankCard',
                //     component: () =>
                //         import ('../components/driver/driverBankCard/driverBankCard.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {

                    //司机业绩导出订单信息
                    path: 'getPerformanceCSV',
                    component: () =>
                        import ('../components/driver/getPerformanceCSV.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /** 广告管理 */
                    //  广告位
                    path: 'advertAppoint',
                    component: () =>
                        import ('../components/advert/advertAppoint/advertAppoint.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //广告库
                    path: 'advertInformation',
                    component: () =>
                        import ('../components/advert/advertInformation/advertInformation.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机推广
                    path: 'driverPromote',
                    component: () =>
                        import ('../components/driver/driverPromote/driverPromote.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //推广审核
                    path: 'examineDriverPromote',
                    component: () =>
                        import ('../components/driver/examineDriverPromote/examineDriverPromote.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //推荐地址
                    path: 'recommendAddress',
                    component: () =>
                        import ('../components/recommendAddress/recommendAddress.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {

                //     //集团管理
                //     path: 'group',
                //     component: () =>
                //         import ('../components/group/group.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {

                    //城市小组
                    path: 'cityTeam',
                    component: () =>
                        import ('../components/city/cityTeam.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // 短信详情
                {
                    path: '/msgCountDetails',
                    component: () =>
                        import ('../components/city/msgCountDetails.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                // 隐私通话
                {
                    path: '/privateNumber',
                    component: () =>
                        import ('../components/city/privateNumber.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                {

                    //管理员日志
                    path: 'adminLog',
                    component: () =>
                        import ('../components/logList/adminLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机活动积分日志
                    path: 'driverRecordActivityPointLists',
                    component: () =>
                        import ('../components/logList/driverRecordActivityPointLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机日志
                    path: 'driverLog',
                    component: () =>
                        import ('../components/logList/driverLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //配置管理
                    path: 'confLists',
                    component: () =>
                        import ('../components/conf/confLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //标签管理
                    path: 'labelLists',
                    component: () =>
                        import ('../components/label/labelLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //客服管理
                    path: 'adminList',
                    component: () =>
                        import ('../components/admin/adminList.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //角色管理
                    path: 'adminRoleLists',
                    component: () =>
                        import ('../components/system/adminRoleLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //清除无用图片
                    path: 'clearImgSubmit',
                    component: () =>
                        import ('../components/upTableSubmit/clearImgSubmit.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /**数据统计 */
                    //   乘客统计
                    path: 'consumerStatistics',
                    component: () =>
                        import ('../components/statistics/consumerStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //   订单核算
                    path: 'orderCheck',
                    component: () =>
                        import ('../components/statistics/orderCheck.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客下单统计
                    path: 'consumerOrderNumLists',
                    component: () =>
                        import ('../components/statistics/consumerOrderNumLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客下单统计
                    path: 'getLegWorkOrderCount',
                    component: () =>
                        import ('../components/statistics/getLegWorkOrderCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //检车卡列表
                    path: 'InspectionCard',
                    component: () =>
                        import ('../components/statistics/InspectionCard.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {

                //     //清分列表
                //     path: 'payLists',
                //     component: () =>
                //         import ('../components/payLists/payLists.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {

                    //司机今日排行
                    path: 'driverCount',
                    component: () =>
                        import ('../components/statistics/driverCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //三倍充值
                    path: 'consumerTripleRecordLists',
                    component: () =>
                        import ('../components/statistics/consumerTripleRecordLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //平安发卡
                    path: 'pingan',
                    component: () =>
                        import ('../components/pingan/pingan.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机统计数据
                    path: 'driverStatistics',
                    component: () =>
                        import ('../components/statistics/driverStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机在线时长
                    path: 'driverDriverStatusLists',
                    component: () =>
                        import ('../components/statistics/driverDriverStatusLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //订单统计
                    path: 'orderStatistics',
                    component: () =>
                        import ('../components/statistics/orderStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //微信支付
                    path: 'wechat',
                    component: () =>
                        import ('../components/wechat/wechat.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //支付宝支付
                    path: 'alipay',
                    component: () =>
                        import ('../components/alipay/alipay.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {
                //     /** 现金券 */
                //     // 现金券列表
                //     path: 'walletkey',
                //     component: () =>
                //         import ('../components/walletkey/walletkey.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                // {

                //     //现金券日志
                //     path: 'walletkeylog',
                //     component: () =>
                //         import ('../components/walletkey/walletkeylog.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                // {
                //     /** 耿师傅优惠卡 */
                //     // 现金券列表
                //     path: 'discountCard',
                //     component: () =>
                //         import ('../components/discountCard/discountCard.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                // {

                //     //现金券日志
                //     path: 'discountCardLog',
                //     component: () =>
                //         import ('../components/discountCard/discountCardLog.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                // {

                //     //现金券日志分类
                //     path: 'discountCardType',
                //     component: () =>
                //         import ('../components/discountCard/discountCardType/discountCardType.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },

                // {
                //     /** 招商加盟 */
                //     // 招商加盟
                //     path: 'merChants',
                //     component: () =>
                //         import ('../components/merchants/merChants.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                // {
                //     /** 挪车码管理 */
                //     // 挪车码
                //     path: 'movecar',
                //     component: () =>
                //         import ('../components/movecar/movecar.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {

                    //活跃度乘客统计
                    path: 'activeConsumerCount',
                    component: () =>
                        import ('../components/statistics/activeConsumerCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //活跃度司机统计
                    path: 'activeDriverCount',
                    component: () =>
                        import ('../components/statistics/activeDriverCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //全部城市订单
                    path: 'getAllCityOrderCount',
                    component: () =>
                        import ('../components/statistics/getAllCityOrderCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //全部城市司机
                    path: 'getAllCityDriverCount',
                    component: () =>
                        import ('../components/statistics/getAllCityDriverCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //全部城市乘客
                    path: 'getAllCityConsumerCount',
                    component: () =>
                        import ('../components/statistics/getAllCityConsumerCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //全国订单金额
                    path: 'getAllCityAmountCount',
                    component: () =>
                        import ('../components/statistics/getAllCityAmountCount/getAllCityAmountCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //第三方全部城市订单
                    path: 'thirdCityOrderCount',
                    component: () =>
                        import ('../components/statistics/thirdCityOrderCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //第三方合作数据
                    path: 'thirdJump',
                    component: () =>
                        import ('../components/statistics/thirdJump.vue'),
                    meta: {

                        requireAuth: true

                    }
                }

            ]
        },
        {
            path: '/Login',
            component: () =>
                import ('../pages/Login.vue'),
            name: 'login'
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js